import { render, staticRenderFns } from "./InfoEditPage.vue?vue&type=template&id=74b05984&scoped=true&"
import script from "./InfoEditPage.vue?vue&type=script&lang=ts&"
export * from "./InfoEditPage.vue?vue&type=script&lang=ts&"
import style0 from "./InfoEditPage.vue?vue&type=style&index=0&id=74b05984&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b05984",
  null
  
)

export default component.exports